declare const validEmail: unique symbol
const EMAIL_ADDRESS_REGEX =
    /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i

export type Email = string & {
    [validEmail]: true
}

export function isValidEmail(input: string): input is Email {
    return EMAIL_ADDRESS_REGEX.test(input)
}

export function getEmail(input: string | null | undefined): Email | undefined {
    if (!input || !isValidEmail(input)) {
        return undefined
    }

    return input
}
